import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { 
  showSuccessToast, 
  showErrorToast, 
  showWarningToast, 
  showInfoToast,
  clearAllToasts 
} from '../store/slices/toastSlice';

/**
 * Custom hook to easily use the toast notification system anywhere in the application
 * @returns {Object} Toast methods
 */
const useToast = () => {
  const dispatch = useDispatch();

  const success = useCallback((message, duration) => {
    dispatch(showSuccessToast(message, duration));
  }, [dispatch]);

  const error = useCallback((message, duration) => {
    dispatch(showErrorToast(message, duration));
  }, [dispatch]);

  const warning = useCallback((message, duration) => {
    dispatch(showWarningToast(message, duration));
  }, [dispatch]);

  const info = useCallback((message, duration) => {
    dispatch(showInfoToast(message, duration));
  }, [dispatch]);

  const clearAll = useCallback(() => {
    dispatch(clearAllToasts());
  }, [dispatch]);

  return {
    success,
    error,
    warning,
    info,
    clearAll
  };
};

// Export as both default and named export for flexibility
export { useToast };
export default useToast;
